import { render, staticRenderFns } from "./SearchBo.vue?vue&type=template&id=97ace84c&"
import script from "./SearchBo.vue?vue&type=script&lang=js&"
export * from "./SearchBo.vue?vue&type=script&lang=js&"
import style0 from "./SearchBo.vue?vue&type=style&index=0&id=97ace84c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports